import { TreeSelect, message } from "antd";
import React, { useEffect, useState } from "react";
import { formatPlanCompta } from "../../../utilities/formattedCategories";
import { getFieldClasses } from "../../../utilities/getFieldClasses";
import Button from "../../Button";
import Overlay from "../../Overlay";
import HeaderOverlay from "../../Project/Header";
import Title from "../../Project/Title";
import { useDispatch, useSelector } from "react-redux";
import { assignPlanComptable } from "../../../data/slices/categories";
import { getPlancompta } from "../../../data/slices/plancompta";
import { useFiltersAndDates } from "../../../hooks/useFiltersAndDate";

function AssignPlanComptaConfirmModal({ open, handleClose, id, data }) {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleCloseFunc = (id) => {
    handleClose(id);
  };

  const dispatch = useDispatch();

  const { constructFilters, getStartAndEndDate } = useFiltersAndDates();

  const { tableConstructedFilters } = constructFilters();

  const { startDate, endDate } = getStartAndEndDate();

  const handleNext = async () => {
    try {
      const result = await dispatch(
        assignPlanComptable({
          categoryId: data?.category?.id,
          planComptableId: selectedOption,
          assignmentType: data?.selectedOption,
          project: {
            mode: "compta",
            projectId: data?.id,
            params: { startDate, endDate, ...tableConstructedFilters },
          },
        })
      );

      if (result.meta.requestStatus !== "rejected") {
        message.success("Plan comptable assigné à la catégorie avec succès");
        handleClose(id);
      } else {
        const apiMessage =
          result.payload? 
          result.payload:
          "Erreur lors de l'affectation du plan comptable";
        message.error(
          typeof apiMessage === "string"
            ? apiMessage
            : "Erreur lors de l'affectation du plan comptable"
        );
      }
    } catch (error) {
      console.error("Error assigning plan comptable:", error);
      message.error("Erreur lors de l'affectation du plan comptable");
    }
  };

  const { plancomptaForSelect } = useSelector((state) => state.plancompta);

  const isCategoryToDefine = (category) => {
    return category?.index === 0 && category?.name === "A définir";
  };

  // Filter out categories that are to be defined and disable them in the tree

  const findDefaultCategoryFromPlanCompta = (data) => {
    if (!data || !Array.isArray(data)) return null;

    for (const item of data) {
      if (isCategoryToDefine(item)) {
        return item.id;
      }

      if (item.children && item.children.length > 0) {
        const found = findDefaultCategoryFromPlanCompta(item.children);
        if (found) return found;
      }
    }
    return null;
  };

  const finalPlanCompta = formatPlanCompta(plancomptaForSelect);

  useEffect(() => {
    // Always fetch plan comptable when modal opens or projectId changes to ensure fresh data for the current project
    if (open && data?.id) {
      dispatch(
        getPlancompta({
          projectId: data?.id,
          isListing: false,
          params: {},
        })
      );
    }
  }, [open, data?.id, dispatch]);

  // Set default category when plancompta data is loaded
  useEffect(() => {
    if (
      plancomptaForSelect &&
      plancomptaForSelect.length > 0 &&
      !selectedOption
    ) {
      const defaultCategory =
        findDefaultCategoryFromPlanCompta(plancomptaForSelect);
      if (defaultCategory) {
        setSelectedOption(defaultCategory);
      }
    }
  }, [plancomptaForSelect, selectedOption]);

  const extractTextFromReactElement = (element) => {
    if (typeof element === 'string' || typeof element === 'number') {
      return String(element);
    }
    
    if (!element || typeof element !== 'object') {
      return '';
    }
    
    if (element.props?.children) {
      const children = element.props.children;
      if (Array.isArray(children)) {
        return children.map(extractTextFromReactElement).join(' ');
      } else {
        return extractTextFromReactElement(children);
      }
    }
    
    return '';
  };

  const filterTreeNode = (inputValue, treeNode) => {
    if (treeNode.disabled) {
      return false;
    }
    
    if (!inputValue) return true;

    const title = treeNode.title?.props?.children;
    if (!title) return false;

    let titleToCheck = Array.isArray(title) ? title[0] : title;
    
    if (typeof titleToCheck !== 'string') {
      titleToCheck = extractTextFromReactElement(titleToCheck);
    }

    if (typeof titleToCheck !== 'string' || !titleToCheck) {
      return false;
    }

    return titleToCheck.toLowerCase().includes(inputValue.toLowerCase());
  };

  const handleBlur = () => {
    // Handle blur event if needed
  };

  return (
    <Overlay show={open} closable={true} onClick={handleCloseFunc}>
      <HeaderOverlay showlogo>
        <Title
          isDelete
          projectTitle={
            <div style={{ width: "95%", margin: "auto" }}>
              Définissez la ligne du plan comptable à affecter à la catégorie.
            </div>
          }
          subTitle={`Affectation d'une ligne d'un plan comptable`}
        />
        <div style={{ width: "70%", margin: "auto", marginBottom: 40 }}>
          <TreeSelect
            showSearch
            filterTreeNode={filterTreeNode}
            bordered={false}
            name="category"
            value={selectedOption}
            dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
            placeholder="Choisir une ligne du plan comptable"
            allowClear
            className={getFieldClasses(selectedOption, true)}
            onBlur={handleBlur}
            onChange={(value) => {
              setSelectedOption(value);
            }}
            treeData={finalPlanCompta}
            treeDefaultExpandedKeys={[`${selectedOption}`]}
          />
        </div>

        <div className="verify-inputs-popup">
          <Button
            text={"Annuler"}
            onClick={() => {
              handleClose(id);
            }}
            className={"action-button"}
          />
          <Button
            text={"Suivant"}
            onClick={handleNext}
            className={"action-button agree-action-button"}
            iconClassName={"delete-icon"}
            disabled={!selectedOption}
          />
        </div>
      </HeaderOverlay>
    </Overlay>
  );
}

export default AssignPlanComptaConfirmModal;
